var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "14", height: "16", viewBox: "0 0 14 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5.5 14.75h5.25a1.5 1.5 0 0 0 1.5-1.5V6.06a.75.75 0 0 0-.22-.53L7.97 1.47a.75.75 0 0 0-.53-.22H3.25a1.5 1.5 0 0 0-1.5 1.5V11m0 3.75l3.66-3.66m0 0a2.251 2.251 0 1 0 3.209-3.157 2.251 2.251 0 0 0-3.21 3.158z", stroke: "#3B97B1", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});